import { RecordColorEnum } from '../../../enums/record-color.enum';
import { UserStatusEnum } from '../enums/user-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function userStatusToColor(status: UserStatusEnum): string {
	switch (status) {
		case UserStatusEnum.ACTIVE:
			return RecordColorEnum.GREEN;

		case UserStatusEnum.INACTIVE:
			return RecordColorEnum.SLATE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
